import { Sword, X } from 'lucide-react'
import type { Skill } from '@/types'

interface ChatSkillChipProps {
  skill: Skill
  onRemove?: () => void
  disabled?: boolean
}

export function ChatSkillChip({ skill, onRemove, disabled = false }: Readonly<ChatSkillChipProps>) {
  return (
    <span
      className="flex min-h-[40px] items-center gap-1.5 rounded-full border bg-muted px-3 py-1 text-sm"
      data-testid="chat-skill-chip"
    >
      <Sword className="h-4 w-4 shrink-0 text-muted-foreground" />
      <span className="max-w-[180px] truncate">{skill.displayName}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className="text-muted-foreground hover:text-foreground disabled:cursor-not-allowed disabled:opacity-50"
          aria-label={`Remove ${skill.displayName}`}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </span>
  )
}
